import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ON_POLICY_SYNCED_FRAGMENT = gql`
  fragment OnPolicySyncedParts on OnPolicySynced {
    policyId
    showSyncAnimation
  }
`;
